import $axios from "@/service/httpServer";
import { baseUrl } from "./oldNew";
// 获取待跟进，已跟进数据
// export const getSearchFollowedCount = (p) =>
//   $axios.get(`${baseUrl}/marketing/adviser/searchFollowedCount`, p);
export const getSearchFollowedCount = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/recommendList`, p);
// 获取用户详情
export const getUserDetail = (p) =>
  $axios.get(`${baseUrl}/marketing/adviser/detail/getCustomerDetail`, p);

// 修改客户姓名
export const changeUserName = (p) =>
  $axios.get(`${baseUrl}/marketing/adviser/detail/modifyCustomerLastName`, p);

// 保存拨打电话记录
export const saveCallRecords = (p) =>
  $axios.post(`${baseUrl}/marketing/adviser/saveConnectRecord`, p);

// 客户是否匹配
export const getIfMatch = (p) =>
  $axios.get(`${baseUrl}/marketing/adviser/detail/saveIsMatch`, p);
//用户验证
export const verifySmsCode = (p) =>
  $axios.get(`${baseUrl}/marketing/adviser/sms/verifySmsCode`, p);

//已到访
// export const visited = (p) =>
//   $axios.get(`${baseUrl}/marketing/adviser/visited`, p);
export const visited = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/recommendList`, p);
//置业顾问_已失效
export const invalid = (p) =>
  $axios.get(`${baseUrl}/marketing/adviser/invalid`, p);
//大数据 - 置业顾问推荐已认购(分页)
export const orderList = (p) =>
  $axios.post(`http://api2.newhope.cn/openapi/open/customer/ldx/order/list`, p);
//大数据 - 置业顾问 - 推荐已签约(分页)
export const signList = (p) =>
  $axios.post(`http://api2.newhope.cn/openapi/open/customer/ldx/sign/list`, p);
//新增-置业顾问-老带新推荐
export const saveOaN = (p) =>
  $axios.post(`${baseUrl}/marketing/recommend/miniProgram/saveOaN`, p);
//查询-置业经理-老业主带访-置业顾问信息
export const getOperatorInfo = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/getOperatorInfo`, p);
//置业顾问-未跟进、已跟进、已到访、已认购、已签约、已失效-列表
// export const adviserFollowList = (p) =>
//   $axios.get(`${baseUrl}/marketing/recommend/App/adviserFollowList`, p);
export const adviserFollowList = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/recommendList`, p);
